module.exports = __webpack_public_path__ + "img/greenHome.9129619d.svg";